import { createComponent, createElement, computed } from "@vue/composition-api";
import { getModulePath } from "@/apps/getPath";
import { AppModule } from "../shared/app";

interface Props {
  module: AppModule;
  action: string;
}

export default createComponent<Props>({
  components: {},
  props: {
    module: { required: true },
    action: { required: false },
  },
  setup(props, ctx) {
    const path = computed(() => getModulePath(props.module, props.action));

    return () =>
      createElement(
        "router-link",
        { props: { to: path.value, ...ctx.attrs }, on: ctx.listeners },
        ctx.slots.default(),
      );
  },
});
